/**
 * Sistema de internacionalización (i18n) para inglés y español
 */

import { warn as logWarn } from './logger';

const translations = {
  es: {
    // Navegación
    nav: {
      recommendations: 'Recomendaciones',
      library: 'Biblioteca',
      openMenu: 'Abrir menú',
      menuSection: 'Navegación',
      menuPreferences: 'Preferencias',
      menuAccount: 'Cuenta',
      history: 'Historial',
      stats: 'Estadísticas',
      settings: 'Configuración',
      blogAdmin: 'Administrar Blog'
    },
    // Recomendaciones
    recommendations: {
      title: 'Recomendaciones',
      loading: 'Cargando recomendaciones...',
      loadingMovies: 'Cargando películas...',
      loadingSeries: 'Cargando series...',
      loadingMusic: 'Cargando música...',
      noRecommendations: 'No tienes recomendaciones aún',
      welcomeNoRecommendations: '¡Bienvenido! Aún no tienes recomendaciones',
      noRecommendationsOfType: 'No tienes recomendaciones de {type} aún',
      generateFirst: 'Para empezar, puedes generar tus primeras recomendaciones basadas en tus preferencias y contenido de otros usuarios.',
      generateType: 'Puedes generar recomendaciones de {type} basadas en tus preferencias y contenido de otros usuarios.',
      generateFirstButton: 'Generar recomendaciones',
      generateTypeButton: 'Generar recomendaciones de {type}',
      generating: 'Generando recomendaciones...',
      generatingFirst: 'Generando…',
      generateFirstRecommendations: 'Generar primeras recomendaciones',
      fillWithAI: 'Sorpréndeme con IA',
      fillWithAIShort: 'Más con IA',
      generateSkippedThreshold: 'Ya tienes suficientes recomendaciones. Usa "Rellenar con IA" para generar más.',
      generationTimeout: 'La generación tardó demasiado (IA o proxy). Espera 1–2 minutos, evita cambiar de red, o usa un modelo más rápido (ej. qwen-flash).',
      generationInProgress: 'Generación en curso, espera…',
      generationNoNewItems: 'La IA respondió pero no se añadió ninguna recomendación nueva (duplicados o formato). Revisa la consola o intenta de nuevo.',
      moviesRecommended: 'Películas Recomendadas',
      seriesRecommended: 'Series Recomendadas',
      musicRecommended: 'Música Recomendada',
      moviesAvailable: '{count} películas disponibles',
      seriesAvailable: '{count} series disponibles',
      musicAvailable: '{count} canciones/álbumes disponibles',
      noMoviesAvailable: 'No hay películas disponibles',
      noSeriesAvailable: 'No hay series disponibles',
      noMusicAvailable: 'No hay música disponible',
      noMoviesFound: 'No se encontraron películas recomendadas. Intenta actualizar la página.',
      noSeriesFound: 'No se encontraron series recomendadas. Intenta actualizar la página.',
      noMusicFound: 'No se encontró música recomendada. Intenta actualizar la página.',
      watched: 'Vista',
      listened: 'Escuchada',
      watchedOn: 'Vista el:',
      listenedOn: 'Escuchada el:',
      yourRating: 'Tu calificación:',
      rating: 'Calificación:',
      markAsWatched: 'Marcar como Vista',
      markAsListened: 'Marcar como Escuchada',
      alreadyWatched: 'Ya Vista',
      alreadyListened: 'Ya Escuchada',
      seasons: 'temporadas',
      retry: 'Reintentar',
      noResultsWithFilters: 'No se encontraron recomendaciones con los filtros aplicados.',
      searchMusicTitle: 'Buscar música para marcar como escuchada',
      searchMusicDescription: 'Busca canciones por nombre/artista o explora por género (cumbia, rock, pop, reggaeton, etc.). Márcalas como escuchadas y se regenerarán las recomendaciones con la IA.',
      searchMoviesTitle: 'Buscar {type} para marcar como vistas',
      searchMoviesDescription: 'Encuentra una película o serie, márcala como vista con tu calificación y se regenerarán las recomendaciones con la IA.',
      results: 'Resultados',
      allGenresOption: 'Todos los géneros',
      markAsWatched: 'Marcar como Visto',
      omit: 'Omitir',
      reactivate: 'Reactivar',
      omitted: 'Omitida',
      new: 'Nueva',
      searchPlaceholder: 'Buscar recomendaciones...',
      allTypes: 'Todos los tipos',
      movies: 'Películas',
      series: 'Series',
      music: 'Música',
      allGenres: 'Todos los géneros',
      filteringBy: 'Filtrando por',
      active: 'Activas',
      omitted: 'Omitidas',
      all: 'Todas',
      favorites: 'Favoritos',
      favoritesActive: 'Favoritos Activos',
      favoritesOmitted: 'Favoritos Omitidos',
      addToFavorites: 'Agregar a favoritos',
      removeFromFavorites: 'Quitar de favoritos',
      sortBy: 'Ordenar por',
      sortDefault: 'Recomendadas (favoritas y mejor nota)',
      sortDateDesc: 'Fecha de recomendación (más recientes)',
      sortDateAsc: 'Fecha de recomendación (más antiguas)',
      sortRatingDesc: 'Calificación promedio (mayor a menor)',
      sortRatingAsc: 'Calificación promedio (menor a mayor)',
      sortExternalDesc: 'Calificación externa (mayor a menor)',
      sortAiDesc: 'Calificación IA (mayor a menor)',
      sortTitleAsc: 'Título (A–Z)',
      averageRating: 'Calificación Promedio',
      externalRating: 'Calificación Externa',
      aiRating: 'Calificación IA',
      userRating: 'Calificación Usuario',
      externalRatingLabel: 'Calificación Externa',
      aiRatingLabel: 'Calificación IA',
      averageLabel: 'Promedio',
      artist: 'Artista',
      actors: 'Actores',
      recommendedAt: 'Recomendada',
      whyRecommended: '¿Por qué se recomienda?',
      readMore: 'Leer más',
      readLess: 'Leer menos',
      showFilters: 'Mostrar filtros',
      hideFilters: 'Ocultar filtros',
      confirmOmit: '¿Omitir "{title}"? No aparecerá en futuras generaciones de recomendaciones.',
      errorLoading: 'Error cargando las recomendaciones.',
      errorGenerating: 'Error generando recomendaciones de {type}. Verifica tu configuración de Groq en Configuración.',
      couldNotGenerate: 'No se pudieron generar recomendaciones de {type}. Verifica tu configuración de Groq en Configuración o agrega contenido visto primero.',
      refresh: 'Actualizar',
      exploreContent: 'Explora películas, series y música recomendadas. Marca como vista/escuchada y califica tu experiencia.',
      processing: 'Procesando...',
      results: 'Resultados',
      clearFilter: 'Quitar filtro',
      errorSearching: 'Error en la búsqueda',
      enterSongOrGenre: 'Ingresa un nombre de canción/artista o selecciona un género',
      movieNamePlaceholder: 'Nombre de la película...',
      seriesNamePlaceholder: 'Nombre de la serie...',
      songOrArtistPlaceholder: 'Nombre de canción o artista...',
      typeMovies: 'películas',
      typeSeries: 'series',
      typeMusic: 'música',
      typeTVSeries: 'series de TV'
    },
    // Historial
    history: {
      title: 'Historial',
      loading: 'Cargando historial...',
      errorLoading: 'Error cargando el historial',
      errorUpdatingRating: 'Error actualizando calificación',
      errorDeletingContent: 'Error eliminando contenido',
      watched: 'Vista',
      listened: 'Escuchada',
      yourRating: 'Tu calificación',
      edit: 'Editar',
      delete: 'Eliminar',
      returnToRecommendations: 'Devolver a Recomendaciones',
      confirmDelete: '¿Eliminar del historial?',
      deleteNote: 'Este contenido volverá a aparecer en las recomendaciones con tu calificación actual',
      deleteAndReturn: 'Eliminar y Devolver a Recomendaciones',
      noContent: 'No hay contenido en el historial',
      noContentWatched: 'No hay contenido {type}',
      whenYouMark: 'Cuando marques contenido como {type}, aparecerá aquí.',
      tabs: {
        movies: 'Películas',
        series: 'Series',
        music: 'Música'
      },
      manageHistory: 'Gestiona tu historial de contenido visto y escuchado. Edita calificaciones o devuelve contenido a las recomendaciones.',
      totalElements: '{count} elementos en total',
      confirmDeleteTitle: 'Confirmar Eliminación',
      confirmDeleteMessage: '¿Estás seguro de que quieres eliminar {title} de tu historial?',
      deleteNoteInfo: 'Este contenido volverá a aparecer en las recomendaciones con tu calificación actual ({rating}) y podrás marcarlo como visto nuevamente.',
      actionCannotBeUndone: 'Esta acción no se puede deshacer.',
      retry: 'Reintentar',
      notes: 'Notas',
      searchPlaceholder: 'Buscar por título, artista, director, género...',
      clearSearch: 'Limpiar búsqueda',
      noResults: 'No se encontraron resultados para "{query}"',
      showingResults: 'Mostrando {filtered} de {total}'
    },
    // Estadísticas
    stats: {
      title: 'Estadísticas',
      subtitle: 'Resumen de lo que has visto y escuchado, con tendencias claras.',
      loading: 'Cargando estadísticas...',
      highRatings: 'Calificaciones 9–10',
      topGenre: 'Género top',
      items: 'ítems',
      noStatsAvailable: 'No hay estadísticas disponibles',
      markContentToSeeStats: 'Marca contenido como visto para ver tus estadísticas.',
      totalWatched: 'Total visto / escuchado',
      movies: 'Películas',
      series: 'Series',
      music: 'Música escuchada',
      thisMonth: 'Este mes',
      titlesWatched: 'título(s) visto(s) / escuchado(s)',
      averageRating: 'Calificación promedio',
      fromAllWatched: 'De todo lo que marcaste como visto o escuchado',
      distributionByType: 'Distribución por tipo',
      noContentByType: 'Aún no hay contenido visto por tipo.',
      favoriteGenres: 'Géneros favoritos',
      markContentToSeeGenres: 'Marca películas, series o música como visto/escuchado para ver tus géneros favoritos.',
      yourRatings: 'Tus calificaciones (1-10)',
      noRatingsYet: 'Aún no hay calificaciones.',
      monthlyActivity: 'Actividad por mes',
      noMonthlyActivity: 'Aún no hay actividad por mes. Marca contenido como visto para ver tu historial.',
      mostListenedArtists: 'Artistas más escuchados',
      movies: 'Películas',
      series: 'Series',
      music: 'Música'
    },
    // Configuración
    settings: {
      title: 'Configuración',
      preferencesTitle: 'Configuración de Preferencias',
      sectionPreferences: 'Preferencias de contenido',
      sectionRatingWeights: 'Pesos de calificación',
      language: 'Idioma',
      languageDescription: 'Cambia el idioma de la interfaz y los prompts de la IA',
      spanish: 'Español',
      english: 'English',
      preferences: 'Preferencias',
      favoriteGenres: 'Géneros Favoritos',
      favoriteGenresExample: '(ej: Acción, Drama, Comedia, Terror)',
      favoriteGenresDescription: 'Categorías temáticas que te gustan (Acción, Drama, Comedia, Terror, etc.)',
      favoriteActors: 'Actores Favoritos',
      preferredMovieTypes: 'Tipos de Películas Preferidos',
      preferredMovieTypesExample: '(ej: Blockbuster, Indie, Clásicas)',
      preferredMovieTypesDescription: 'Estilo o tipo de producción que prefieres (Blockbuster, Indie, Clásicas, Documentales, etc.)',
      addGenre: 'Añadir género',
      addActor: 'Añadir actor',
      add: 'Agregar',
      actorNamePlaceholder: 'Nombre del actor',
      genreNamePlaceholder: 'Nombre del género',
      movieTypePlaceholder: 'Tipo de película',
      minimumRating: 'Calificación Mínima',
      minimumRatingDescription: 'Solo se mostrarán recomendaciones con calificación igual o superior',
      maxRecommendations: 'Máximo de Recomendaciones',
      preferredLanguage: 'Idioma Preferido',
      spanishOption: 'Español',
      englishOption: 'Inglés',
      anyLanguage: 'Cualquiera',
      contentRating: 'Clasificación de Contenido',
      contentRatingG: 'G - General',
      contentRatingPG: 'PG - Guía Parental',
      contentRatingPG13: 'PG-13 - Mayores de 13',
      contentRatingR: 'R - Restringido',
      contentRatingNC17: 'NC-17 - Solo Adultos',
      ratingWeights: 'Pesos de Calificaciones',
      userRatingWeight: 'Calificación Usuario',
      externalRatingWeight: 'Calificación Externa',
      aiRatingWeight: 'Calificación IA',
      weightsDescription: 'Los pesos deben sumar 1.0 en total. Peso actual: {total}',
      saving: 'Guardando...',
      savePreferences: 'Guardar Preferencias',
      preferencesSaved: 'Preferencias guardadas correctamente en el archivo JSON.',
      errorSaving: 'Error guardando las preferencias',
      errorLoadingQuota: 'Error cargando quota de Groq',
      aiProvider: 'Proveedor de IA',
      aiProviderTitle: 'Proveedor de IA',
      aiProviderDescription: 'Groq (nube)',
      aiProviderNote: 'Groq es el proveedor principal. Si Groq no está disponible, se usa Alibaba Cloud (Singapur) si configuraste su API key; si no, el pool de la comunidad.',
      groqApiKey: 'API Key de Groq',
      groqApiKeyPlaceholder: 'Pega aquí tu API key',
      groqApiKeyConfigured: '•••••••• (ya configurada en tu cuenta)',
      noApiKey: '¿No tienes una API key?',
      getApiKey: 'Obtén una gratis en Groq',
      getApiKeyNote: '(gratis, solo necesitas crear una cuenta)',
      saveApiKey: 'Guardar claves de IA',
      alibabaSectionTitle: 'Alibaba Cloud (Singapur) — respaldo',
      alibabaApiKey: 'API Key de Alibaba Cloud',
      alibabaApiKeyPlaceholder: 'Pega tu API key (región internacional / Singapur)',
      alibabaApiKeyConfigured: '•••••••• (ya configurada en tu cuenta)',
      alibabaModel: 'Modelo Qwen',
      alibabaModelHelp: 'Escribe o elige un ID de Model Studio (Singapur), ej. qwen3.5-27b, qwen-plus. Debe coincidir con la documentación de Alibaba.',
      alibabaGetApiKey: 'Obtener API key en Model Studio',
      alibabaStatus: 'Estado Alibaba Cloud',
      alibabaAvailable: 'Alibaba Cloud disponible',
      alibabaNotAvailable: 'Alibaba Cloud no disponible',
      alibabaConfigureKey: 'Configura tu API key de Alibaba para usarlo cuando Groq falle',
      alibabaEnableSearch: 'Búsqueda en internet (Alibaba)',
      alibabaEnableSearchHelp:
        'Solo cuando Groq falle y se use Alibaba. Consulta la web (más lento/coste). No se puede combinar con JSON estricto de Alibaba: la app parsea el JSON del texto. Modelos: qwen3.6-flash, qwen3.5-plus. No qwen3.5-27b.',
      alibabaEnableSearchModelOk: 'Este modelo debería soportar búsqueda web.',
      alibabaEnableSearchModelWarning:
        'Este modelo probablemente no soporta búsqueda web. Cambia a qwen3.5-plus o qwen3-max y guarda.',
      alibabaEnableSearchModelBlocked:
        'Este modelo (27b/120b, etc.) no admite búsqueda web. Usa qwen3.6-flash o qwen3.5-plus.',
      alibabaEnableSearchModelTry:
        'Con tu modelo se intentará enable_search al usar Alibaba (guarda la API key). Si falla, prueba qwen3.5-plus.',
      updateAlibabaStatus: 'Comprobar estado',
      systemStatus: 'Estado del Sistema',
      aiConnected: 'IA Conectado',
      aiDisconnected: 'IA Desconectado',
      groqQuota: 'Quota de Groq',
      checkingQuota: 'Verificando quota de Groq...',
      groqAvailable: 'Groq disponible',
      requestsRemaining: 'Quedan {remaining} requests disponibles{limit}',
      noRequestsAvailable: 'Sin requests disponibles',
      groqNotAvailable: 'Groq no disponible',
      retryAfter: 'Intenta de nuevo en {seconds} segundos',
      paymentRequired: 'Se requiere actualizar el plan de pago de Groq',
      updateQuotaToSee: 'Haz clic en "Actualizar quota" para ver tu disponibilidad',
      configureApiKeyToSee: 'Configura tu API key de Groq para ver tu quota disponible',
      checking: 'Verificando...',
      updateQuota: 'Actualizar quota',
      noAIServiceNote: 'Sin servicio de IA no se podrán generar nuevas recomendaciones automáticas.',
      preferencesSummary: 'Resumen de Preferencias',
      actors: 'Actores',
      genres: 'Géneros',
      movieTypes: 'Tipos de películas',
      minimumRatingLabel: 'Calificación mínima',
      maxRecommendationsLabel: 'Máx. recomendaciones',
      languageLabel: 'Idioma',
      ratingLabel: 'Clasificación'
    },
    // Modal de calificación
    ratingModal: {
      rateContent: 'Calificar contenido',
      editRating: 'Editar Calificación',
      rate: 'Calificar',
      howWouldYouRate: '¿Cómo calificarías este contenido?',
      ratingMethod: 'Método de calificación',
      slider: 'Deslizador',
      stars: 'Estrellas',
      buttons: 'Botones',
      thumbs: 'Pulgares',
      notes: 'Notas (opcional)',
      save: 'Guardar',
      cancel: 'Cancelar',
      markAsWatched: 'Marcar como Visto',
      genre: 'Género principal',
      selectGenre: 'Seleccionar género',
      selectGenreAria: 'Seleccionar género musical',
      selectGenrePlaceholder: '— Seleccionar género —',
      correctGenre: 'Corrige o añade el género si la API puso "Varios".',
      selectCorrectGenre: 'Elige el género en la lista. Si la API puso "Varios", selecciona el correcto.',
      contentInfo: 'Información del Contenido',
      type: 'Tipo',
      genreLabel: 'Género',
      year: 'Año',
      artist: 'Artista',
      director: 'Director',
      actors: 'Actores',
      rating: 'Calificación',
      ratingValue: 'Calificación: {value}/10',
      selectRating: 'Selecciona una calificación',
      veryBad: 'Muy malo',
      bad: 'Malo',
      regular: 'Regular',
      good: 'Bueno',
      excellent: 'Excelente',
      didYouLike: '¿Te gustó?',
      liked: 'Me gustó',
      disliked: 'No me gustó',
      description: 'Descripción',
      whyRecommended: '¿Por qué se recomienda?',
      notesPlaceholder: 'Comparte tu opinión sobre este contenido...'
    },
    // Landing Page
    landing: {
      heroBadge: '✨ Descubrimiento de Entretenimiento con IA',
      heroTitle: 'Descubre tu próxima',
      heroTitleHighlight: 'película, serie o canción favorita',
      heroTitleSuffix: '',
      heroSubtitle: 'Deja de perder tiempo buscando. Obtén recomendaciones personalizadas con IA que aprende de tu historial real de películas, series y música. Solo títulos reales y verificados, con razones claras de por qué te encantarán.',
      featureRealTitles: '100% Títulos Reales',
      featureAIPowered: 'Impulsado por IA',
      featureFreeForever: 'Gratis Para Siempre',
      ctaButton: 'Empezar Gratis',
      trustText: 'Sin tarjeta de crédito',
      cardMovies: 'Películas',
      cardSeries: 'Series',
      cardMusic: 'Música',
      featuresTitle: 'Todo lo que necesitas para descubrir contenido increíble',
      featuresSubtitle: 'Un sistema completo de recomendaciones que se adapta a tus gustos',
      featurePersonalizedTitle: 'Recomendaciones personalizadas',
      featurePersonalizedDesc: 'La IA analiza lo que ya viste y escuchaste para sugerirte películas, series y música reales y verificadas, con una razón clara para cada recomendación.',
      featureRateTitle: 'Califica y refina',
      featureRateDesc: 'Marca como visto o escuchado y califica con tu nota. Las siguientes recomendaciones se ajustarán según lo que te gustó y lo que no.',
      featureTrackTitle: 'Sigue tu actividad',
      featureTrackDesc: 'Visualiza estadísticas detalladas: géneros favoritos, artistas más escuchados, actividad mensual y distribución de calificaciones. Comprende mejor tus hábitos de entretenimiento.',
      featureSearchTitle: 'Búsqueda y filtros inteligentes',
      featureSearchDesc: 'Busca películas, series y música fácilmente. Filtra recomendaciones por género, tipo o estado. Encuentra exactamente lo que buscas en segundos.',
      featureControlTitle: 'Controla tus recomendaciones',
      featureControlDesc: 'Omite recomendaciones que no te interesan y reactívalas después si cambias de opinión. Tu lista de recomendaciones se adapta a tus preferencias en tiempo real.',
      featureOwnAITitle: 'Tu propia IA (opcional)',
      featureOwnAIDesc: 'Puedes usar tu propia clave de API de Groq para generar recomendaciones. Tus datos y tu clave permanecen privados y seguros en tu cuenta.',
      howItWorksTitle: 'Cómo funciona',
      howItWorksSubtitle: 'Tres pasos simples para un mejor entretenimiento',
      step1Title: 'Inicia sesión',
      step1Desc: 'Acceso rápido y seguro con tu cuenta de Google. Sin contraseñas que recordar ni formularios complicados.',
      step2Title: 'Califica lo que has visto',
      step2Desc: 'Marca películas, series y música que ya disfrutaste y califícalas. Cuanto más califiques, mejores y más precisas serán tus recomendaciones.',
      step3Title: 'Obtén recomendaciones personalizadas',
      step3Desc: 'La IA analiza tus preferencias y sugiere títulos reales y verificados que realmente querrás ver o escuchar.',
      ctaTitle: '¿Listo para descubrir tu próximo favorito?',
      ctaSubtitle: 'Únete a nuestra comunidad y encuentra tu entretenimiento perfecto.',
      ctaButtonSecondary: 'Entrar con Google',
      footerText: 'Películas, series y música recomendadas por IA · Tus datos permanecen privados y seguros en tu cuenta',
      footerCopyright: '© 2026 MisKosas · Impulsado por IA',
      latestNewsTitle: 'Últimas noticias',
      latestNewsReadMore: 'Leer más',
      latestNewsNone: 'No hay noticias recientes.',
      allNewsLink: 'Aquí todas las noticias',
      // Auth errors
      errorGoogleNotConfigured: 'Google OAuth no está configurado en el servidor.',
      errorGoogleAuthFailed: 'Error al autenticar con Google. Intenta de nuevo.',
      errorNoUser: 'No se pudo crear o obtener el usuario.',
      errorCallback: 'Error en el proceso de autenticación.',
      errorSession: 'Error al guardar la sesión.',
      errorSignIn: 'Error al iniciar sesión con Google.',
      errorSignInGeneric: 'Error al iniciar sesión.',
      errorConnection: 'Error de conexión.',
      // Modal
      modalCreateAccount: 'Crear cuenta',
      modalSignIn: 'Iniciar sesión',
      modalEmailLabel: 'Email',
      modalEmailPlaceholder: 'tu@email.com',
      modalNameLabel: 'Nombre (opcional)',
      modalNamePlaceholder: 'Tu nombre',
      modalPasswordLabel: 'Contraseña',
      modalPasswordPlaceholder: 'Contraseña',
      modalPasswordPlaceholderRegister: 'Mínimo 6 caracteres',
      modalSignUp: 'Registrarme',
      modalSignInButton: 'Entrar',
      modalAlreadyHaveAccount: 'Ya tengo cuenta',
      modalCreateAccountLink: 'Crear cuenta',
      modalSignInEmail: 'Entrar con email'
    },
    publicLayout: {
      backToHome: 'Volver al inicio',
      goToApp: 'Ir a la app'
    },
    cards: {
      typeMovie: 'Película',
      typeSeries: 'Serie',
      typeMusic: 'Música'
    },
    library: {
      segmentRecommendations: 'Por descubrir',
      segmentWatched: 'Ya visto',
      hintRecommendations: 'Títulos sugeridos por la IA según tus gustos. Márcalos como vistos cuando los consumas.',
      hintWatched: 'Lo que ya marcaste como visto o escuchado. Puedes editar la nota o devolverlo a recomendaciones.'
    },
    // Página Todas las noticias
    allNews: {
      title: 'Todas las noticias',
      subtitle: 'Artículos y novedades del blog',
      backToHome: 'Volver al inicio',
      loading: 'Cargando noticias...',
      noPosts: 'No hay noticias publicadas.',
      readMore: 'Leer más'
    },
    // Tutorial de Groq
    groqTutorial: {
      back: 'Volver',
      title: 'Cómo Configurar Groq API para Recomendaciones Reales',
      subtitle: 'Aprende cómo obtener tu clave API gratuita de Groq en menos de 5 minutos',
      whyNeededTitle: '¿Por qué necesitas Groq?',
      whyNeeded: 'Para generar recomendaciones reales y personalizadas, necesitamos acceso a modelos de IA avanzados. Groq proporciona este servicio de forma rápida y económica.',
      freeTitle: 'Plan Gratuito Disponible',
      freeDescription: 'Groq ofrece un plan gratuito generoso con límites diarios. Para uso personal, es más que suficiente y no requiere tarjeta de crédito.',
      step1Title: 'Crear una cuenta en Groq',
      step1Description: 'Visita la consola de Groq y crea una cuenta gratuita. Puedes usar tu cuenta de Google para iniciar sesión rápidamente.',
      openConsole: 'Abrir Consola de Groq',
      step1Note: 'Nota: El registro es completamente gratuito y no requiere tarjeta de crédito.',
      step2Title: 'Generar tu API Key',
      step2Description: 'Una vez dentro de la consola, ve a la sección de API Keys y crea una nueva clave. Cópiala inmediatamente porque solo se mostrará una vez.',
      step2Code: 'gsk_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
      copy: 'Copiar',
      copied: '¡Copiado!',
      step3Title: 'Configurar en MisKosas',
      step3Description: 'Ahora que tienes tu API Key, sigue estos pasos para configurarla:',
      step3Item1: 'Ve a la sección de Configuración en tu dashboard',
      step3Item2: 'Pega tu API Key de Groq en el campo correspondiente',
      step3Item3: 'Guarda los cambios y ¡listo! Ya puedes generar recomendaciones reales',
      goToSettings: 'Ir a Configuración',
      faqTitle: 'Preguntas Frecuentes',
      faq1Question: '¿Es realmente gratis?',
      faq1Answer: 'Sí, Groq ofrece un plan gratuito con límites generosos. Para uso personal de recomendaciones, es más que suficiente. Solo pagarías si excedes los límites del plan gratuito.',
      faq2Question: '¿Necesito tarjeta de crédito?',
      faq2Answer: 'No, el plan gratuito de Groq no requiere tarjeta de crédito. Puedes empezar a usarlo inmediatamente después de crear tu cuenta.',
      faq3Question: '¿Es seguro compartir mi API Key?',
      faq3Answer: 'Tu API Key se almacena de forma segura en tu cuenta y solo tú puedes verla. Nunca la compartas públicamente. En MisKosas, tu clave se guarda de forma encriptada y solo se usa para generar tus recomendaciones.',
      faq4Question: '¿Qué pasa si excedo los límites gratuitos?',
      faq4Answer: 'Groq tiene límites muy generosos. Si los excedes, puedes configurar límites de gasto en tu cuenta de Groq o considerar actualizar a un plan de pago. Los precios son muy económicos (desde $0.05 por millón de tokens).',
      readyTitle: '¿Listo para empezar?',
      readyDescription: 'Configura tu API Key de Groq ahora y comienza a recibir recomendaciones reales y personalizadas.',
      configureNow: 'Configurar Ahora',
      learnMore: 'Aprende más sobre Groq',
      linkText: 'Ver tutorial completo'
    },
    // Mensajes generales
    common: {
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      save: 'Guardar',
      delete: 'Eliminar',
      edit: 'Editar',
      close: 'Cerrar',
      search: 'Buscar',
      filter: 'Filtrar',
      noResults: 'No se encontraron resultados',
      noData: 'No hay datos disponibles',
      note: 'Nota',
      logout: 'Cerrar sesión',
      aiServiceNotAvailable: 'El servicio de IA no está disponible. No se podrán generar nuevas recomendaciones automáticas.',
      learnHowToConfigure: 'Aprende cómo configurar Groq API para recomendaciones reales →',
      errorLoadingData: 'Error cargando los datos.',
      aiAvailable: 'IA disponible',
      aiNotAvailable: 'IA no disponible',
      errorGeneratingRecommendations: 'Error generando recomendaciones',
      generatingRecommendations: 'Generando recomendaciones...',
      errorMarkingWatched: 'Error marcando el contenido como visto.',
      errorUpdatingPreferences: 'Error actualizando las preferencias.',
      errorLoadingMovies: 'Error cargando las películas',
      errorLoadingSeries: 'Error cargando las series',
      errorLoadingMusic: 'Error cargando la música',
      errorMarkingListened: 'Error marcando como escuchada',
      checkingAuth: 'Verificando sesión...',
      // Blog
      blog: {
        loading: 'Cargando...',
        error: 'Error',
        postNotFound: 'Post no encontrado',
        errorLoading: 'Error cargando el post',
        backToHome: 'Volver al inicio',
        views: 'vistas',
        rateThisContent: 'Calificar este contenido',
        rateMovie: 'Calificar esta película',
        rateSeries: 'Añadir esta serie a mi lista',
        rateMusic: 'Calificar esta canción',
        goToRate: 'Ir a calificar',
        adminTitle: 'Administración del Blog',
        newPost: 'Nuevo Post',
        editPost: 'Editar Post',
        title: 'Título',
        category: 'Categoría',
        status: 'Estado',
        publishedAt: 'Fecha de publicación',
        actions: 'Acciones',
        noPosts: 'No hay posts aún',
        published: 'Publicado',
        draft: 'Borrador',
        viewPost: 'Ver post',
        edit: 'Editar',
        delete: 'Eliminar',
        confirmDelete: '¿Estás seguro de que quieres eliminar este post?',
        errorDeleting: 'Error al eliminar el post',
        errorSaving: 'Error al guardar el post',
        saving: 'Guardando...',
        save: 'Guardar',
        excerpt: 'Resumen',
        excerptPlaceholder: 'Resumen corto del post (opcional)',
        excerptHelp: 'Este texto aparecerá en las vistas previas y en los meta tags',
        content: 'Contenido',
        contentPlaceholder: 'Escribe el contenido del post en HTML...',
        contentHelp: 'Puedes usar HTML para formatear el contenido',
        featuredImage: 'Imagen destacada',
        imageUrlPlaceholder: 'URL de la imagen destacada',
        uploadImage: 'Subir imagen',
        uploadingImage: 'Subiendo…',
        uploadImageHelp: 'Sube una imagen o pega una URL',
        seoSettings: 'Configuración SEO',
        metaTitle: 'Meta Título',
        metaTitlePlaceholder: 'Título para SEO (opcional, por defecto usa el título del post)',
        metaTitleHelp: 'Si se deja vacío, se usará el título del post',
        metaDescription: 'Meta Descripción',
        metaDescriptionPlaceholder: 'Descripción para SEO (opcional)',
        metaDescriptionHelp: 'Descripción que aparecerá en los resultados de búsqueda',
        metaKeywords: 'Meta Keywords',
        metaKeywordsPlaceholder: 'Palabras clave separadas por comas',
        metaKeywordsHelp: 'Palabras clave para SEO (opcional)',
        titlePlaceholder: 'Título del post',
        adminAccessDenied: 'Acceso denegado. Se requiere rol de superusuario.',
        accessDeniedOops: '¡Uy!',
        accessDeniedTitle: '¡No deberías estar aquí!',
        accessDeniedMessage: 'Este rincón es solo para los superusuarios. Pero no te preocupes, te devolvemos a tu rumbo en un momento.',
        accessDeniedRedirect: 'Volviendo al inicio en {seconds} segundos...',
        generateWithAI: 'Generar con IA',
        generateTopicLabel: 'Tema del artículo',
        generateTopicPlaceholder: 'Ej: Selena Gómez canción nueva, película Duna 2, serie The Last of Us',
        generateTopicHelp: 'Describe en pocas palabras de qué quieres el artículo (película, serie o música).',
        generating: 'Generando artículo...',
        generateError: 'Error al generar el artículo.',
        generateSuccess: 'Borrador creado. Revisa, añade imagen si quieres y publica.',
        generateLanguageLabel: 'Idioma del artículo',
        generateLanguageEs: 'Español',
        generateLanguageEn: 'English',
        generateLanguageHelp: 'Genera el mismo tema en otro idioma para tener versiones ES/EN.',
        usageTitle: 'Uso de la generación (Groq)',
        promptSentTitle: 'Prompt enviado al LLM',
        promptSentSystem: 'Prompt de sistema',
        promptSentUser: 'Prompt del usuario',
        relatedTitleLabel: 'Título real (para enlace Calificar)',
        relatedTitlePlaceholder: 'Ej. El padrino',
        relatedYearLabel: 'Año (para enlace Calificar)',
        relatedYearPlaceholder: '1972',
        usagePromptTokens: 'Tokens de entrada',
        usageCompletionTokens: 'Tokens de salida',
        usageTotalTokens: 'Tokens totales',
        usageModel: 'Modelo',
        usageResponseTime: 'Tiempo de respuesta',
        postLanguage: 'Idioma del post (URL)',
        postLanguageHelp: 'ES: /noticias/peliculas/... — EN: /news/movies/...',
        searchPlaceholder: 'Buscar por título, slug o resumen...',
        searchButton: 'Buscar',
        filterStatus: 'Estado',
        filterStatusAll: 'Todos',
        filterStatusPublished: 'Publicados',
        filterStatusDraft: 'Borradores',
        searchImagesOnGoogle: 'Buscar imágenes grandes en Google',
        page: 'Página',
        prev: 'Anterior',
        next: 'Siguiente',
        showingCount: 'Mostrando {from}-{to} de {total}',
        mightAlsoLike: 'También podría interesarte'
      },
      loadingModalDefaultTitle: 'Generando recomendaciones...',
      loadingModalDefaultMessage: 'Consultando con la IA...',
      loadingModalCloseAndReload: 'Cerrar y recargar',
      loadingModalConnecting: 'Consultando con la IA...',
      loadingModalAnalyzing: 'Analizando tus preferencias...',
      loadingModalGenerating: 'Generando recomendaciones personalizadas...',
      loadingModalDetecting: 'Detectando duplicados...',
      loadingModalSaving: 'Guardando recomendaciones actualizadas...',
      paginationShowing: 'Mostrando {from}–{to} de {total}',
      paginationPage: 'Página {page} de {totalPages}'
    }
  },
  en: {
    // Navigation
    nav: {
      recommendations: 'Recommendations',
      library: 'Library',
      openMenu: 'Open menu',
      menuSection: 'Navigation',
      menuPreferences: 'Preferences',
      menuAccount: 'Account',
      history: 'History',
      stats: 'Statistics',
      settings: 'Settings',
      blogAdmin: 'Manage Blog'
    },
    // Recommendations
    recommendations: {
      title: 'Recommendations',
      loading: 'Loading recommendations...',
      loadingMovies: 'Loading movies...',
      loadingSeries: 'Loading series...',
      loadingMusic: 'Loading music...',
      noRecommendations: 'You have no recommendations yet',
      welcomeNoRecommendations: 'Welcome! You have no recommendations yet',
      noRecommendationsOfType: 'You have no {type} recommendations yet',
      generateFirst: 'To get started, you can generate your first recommendations based on your preferences and content from other users.',
      generateType: 'You can generate {type} recommendations based on your preferences and content from other users.',
      generateFirstButton: 'Generate recommendations',
      generateTypeButton: 'Generate {type} recommendations',
      generating: 'Generating recommendations...',
      generatingFirst: 'Generating…',
      generateFirstRecommendations: 'Generate first recommendations',
      fillWithAI: 'Surprise me with AI',
      fillWithAIShort: 'More with AI',
      generateSkippedThreshold: 'You already have enough recommendations. Use "Fill with AI" to generate more.',
      generationTimeout: 'Generation took too long (AI or proxy). Wait 1–2 minutes, avoid switching networks, or use a faster model (e.g. qwen-flash).',
      generationInProgress: 'Generation in progress, please wait…',
      generationNoNewItems: 'AI responded but no new recommendations were added (duplicates or format). Check the console or try again.',
      moviesRecommended: 'Recommended Movies',
      seriesRecommended: 'Recommended Series',
      musicRecommended: 'Recommended Music',
      moviesAvailable: '{count} movies available',
      seriesAvailable: '{count} series available',
      musicAvailable: '{count} songs/albums available',
      noMoviesAvailable: 'No movies available',
      noSeriesAvailable: 'No series available',
      noMusicAvailable: 'No music available',
      noMoviesFound: 'No recommended movies found. Try refreshing the page.',
      noSeriesFound: 'No recommended series found. Try refreshing the page.',
      noMusicFound: 'No recommended music found. Try refreshing the page.',
      watched: 'Watched',
      listened: 'Listened',
      watchedOn: 'Watched on:',
      listenedOn: 'Listened on:',
      yourRating: 'Your rating:',
      rating: 'Rating:',
      markAsWatched: 'Mark as Watched',
      markAsListened: 'Mark as Listened',
      alreadyWatched: 'Already Watched',
      alreadyListened: 'Already Listened',
      seasons: 'seasons',
      retry: 'Retry',
      noResultsWithFilters: 'No recommendations found with the applied filters.',
      searchMusicTitle: 'Search music to mark as listened',
      searchMusicDescription: 'Search songs by name/artist or explore by genre (cumbia, rock, pop, reggaeton, etc.). Mark them as listened and recommendations will be regenerated with AI.',
      searchMoviesTitle: 'Search {type} to mark as watched',
      searchMoviesDescription: 'Find a movie or series, mark it as watched with your rating and recommendations will be regenerated with AI.',
      results: 'Results',
      allGenresOption: 'All genres',
      markAsWatched: 'Mark as Watched',
      omit: 'Omit',
      reactivate: 'Reactivate',
      omitted: 'Omitted',
      new: 'New',
      searchPlaceholder: 'Search recommendations...',
      allTypes: 'All types',
      movies: 'Movies',
      series: 'Series',
      music: 'Music',
      allGenres: 'All genres',
      filteringBy: 'Filtering by',
      active: 'Active',
      omitted: 'Omitted',
      all: 'All',
      favorites: 'Favorites',
      favoritesActive: 'Active Favorites',
      favoritesOmitted: 'Omitted Favorites',
      addToFavorites: 'Add to favorites',
      removeFromFavorites: 'Remove from favorites',
      sortBy: 'Sort by',
      sortDefault: 'Recommended (favorites and top rated)',
      sortDateDesc: 'Recommendation date (newest first)',
      sortDateAsc: 'Recommendation date (oldest first)',
      sortRatingDesc: 'Average rating (high to low)',
      sortRatingAsc: 'Average rating (low to high)',
      sortExternalDesc: 'External rating (high to low)',
      sortAiDesc: 'AI rating (high to low)',
      sortTitleAsc: 'Title (A–Z)',
      averageRating: 'Average Rating',
      externalRating: 'External Rating',
      aiRating: 'AI Rating',
      userRating: 'User Rating',
      externalRatingLabel: 'External Rating',
      aiRatingLabel: 'AI Rating',
      averageLabel: 'Average',
      artist: 'Artist',
      actors: 'Actors',
      recommendedAt: 'Recommended',
      whyRecommended: 'Why is this recommended?',
      readMore: 'Read more',
      readLess: 'Read less',
      showFilters: 'Show filters',
      hideFilters: 'Hide filters',
      confirmOmit: 'Omit "{title}"? It will not appear in future recommendation generations.',
      errorLoading: 'Error loading recommendations.',
      errorGenerating: 'Error generating {type} recommendations. Check your Groq configuration in Settings.',
      couldNotGenerate: 'Could not generate {type} recommendations. Check your Groq configuration in Settings or add watched content first.',
      refresh: 'Refresh',
      exploreContent: 'Explore recommended movies, series and music. Mark as watched/listened and rate your experience.',
      processing: 'Processing...',
      results: 'Results',
      clearFilter: 'Remove filter',
      errorSearching: 'Search error',
      enterSongOrGenre: 'Enter a song/artist name or select a genre',
      movieNamePlaceholder: 'Movie name...',
      seriesNamePlaceholder: 'Series name...',
      songOrArtistPlaceholder: 'Song or artist name...',
      typeMovies: 'movies',
      typeSeries: 'TV series',
      typeMusic: 'music',
      typeTVSeries: 'TV series'
    },
    // History
    history: {
      title: 'History',
      loading: 'Loading history...',
      errorLoading: 'Error loading history',
      errorUpdatingRating: 'Error updating rating',
      errorDeletingContent: 'Error deleting content',
      watched: 'Watched',
      listened: 'Listened',
      yourRating: 'Your rating',
      edit: 'Edit',
      delete: 'Delete',
      returnToRecommendations: 'Return to Recommendations',
      confirmDelete: 'Delete from history?',
      deleteNote: 'This content will reappear in recommendations with your current rating',
      deleteAndReturn: 'Delete and Return to Recommendations',
      noContent: 'No content in history',
      noContentWatched: 'No {type} content',
      whenYouMark: 'When you mark content as {type}, it will appear here.',
      tabs: {
        movies: 'Movies',
        series: 'Series',
        music: 'Music'
      },
      manageHistory: 'Manage your history of watched and listened content. Edit ratings or return content to recommendations.',
      totalElements: '{count} elements in total',
      confirmDeleteTitle: 'Confirm Deletion',
      confirmDeleteMessage: 'Are you sure you want to delete {title} from your history?',
      deleteNoteInfo: 'This content will reappear in recommendations with your current rating ({rating}) and you can mark it as watched again.',
      actionCannotBeUndone: 'This action cannot be undone.',
      retry: 'Retry',
      notes: 'Notes',
      searchPlaceholder: 'Search by title, artist, director, genre...',
      clearSearch: 'Clear search',
      noResults: 'No results found for "{query}"',
      showingResults: 'Showing {filtered} of {total}'
    },
    // Statistics
    stats: {
      title: 'Statistics',
      subtitle: 'A clear overview of what you have watched and listened to.',
      loading: 'Loading statistics...',
      highRatings: 'Ratings 9–10',
      topGenre: 'Top genre',
      items: 'items',
      noStatsAvailable: 'No statistics available',
      markContentToSeeStats: 'Mark content as watched to see your statistics.',
      totalWatched: 'Total watched / listened',
      movies: 'Movies',
      series: 'Series',
      music: 'Music listened',
      thisMonth: 'This month',
      titlesWatched: 'title(s) watched / listened',
      averageRating: 'Average rating',
      fromAllWatched: 'From everything you marked as watched or listened',
      distributionByType: 'Distribution by type',
      noContentByType: 'No content watched by type yet.',
      favoriteGenres: 'Favorite genres',
      markContentToSeeGenres: 'Mark movies, series or music as watched/listened to see your favorite genres.',
      yourRatings: 'Your ratings (1-10)',
      noRatingsYet: 'No ratings yet.',
      monthlyActivity: 'Monthly activity',
      noMonthlyActivity: 'No monthly activity yet. Mark content as watched to see your history.',
      mostListenedArtists: 'Most listened artists',
      movies: 'Movies',
      series: 'Series',
      music: 'Music'
    },
    // Settings
    settings: {
      title: 'Settings',
      preferencesTitle: 'Preferences Configuration',
      sectionPreferences: 'Content preferences',
      sectionRatingWeights: 'Rating weights',
      language: 'Language',
      languageDescription: 'Change the language of the interface and AI prompts',
      spanish: 'Español',
      english: 'English',
      preferences: 'Preferences',
      favoriteGenres: 'Favorite Genres',
      favoriteGenresExample: '(e.g.: Action, Drama, Comedy, Horror)',
      favoriteGenresDescription: 'Thematic categories you like (Action, Drama, Comedy, Horror, etc.)',
      favoriteActors: 'Favorite Actors',
      preferredMovieTypes: 'Preferred Movie Types',
      preferredMovieTypesExample: '(e.g.: Blockbuster, Indie, Classics)',
      preferredMovieTypesDescription: 'Style or type of production you prefer (Blockbuster, Indie, Classics, Documentaries, etc.)',
      addGenre: 'Add genre',
      addActor: 'Add actor',
      add: 'Add',
      actorNamePlaceholder: 'Actor name',
      genreNamePlaceholder: 'Genre name',
      movieTypePlaceholder: 'Movie type',
      minimumRating: 'Minimum Rating',
      minimumRatingDescription: 'Only recommendations with equal or higher rating will be shown',
      maxRecommendations: 'Maximum Recommendations',
      preferredLanguage: 'Preferred Language',
      spanishOption: 'Spanish',
      englishOption: 'English',
      anyLanguage: 'Any',
      contentRating: 'Content Rating',
      contentRatingG: 'G - General',
      contentRatingPG: 'PG - Parental Guidance',
      contentRatingPG13: 'PG-13 - Ages 13+',
      contentRatingR: 'R - Restricted',
      contentRatingNC17: 'NC-17 - Adults Only',
      ratingWeights: 'Rating Weights',
      userRatingWeight: 'User Rating',
      externalRatingWeight: 'External Rating',
      aiRatingWeight: 'AI Rating',
      weightsDescription: 'Weights must sum to 1.0 total. Current weight: {total}',
      saving: 'Saving...',
      savePreferences: 'Save Preferences',
      preferencesSaved: 'Preferences saved successfully to JSON file.',
      errorSaving: 'Error saving preferences',
      errorLoadingQuota: 'Error loading Groq quota',
      aiProvider: 'AI Provider',
      aiProviderTitle: 'AI Provider',
      aiProviderDescription: 'Groq (cloud)',
      aiProviderNote: 'Groq is the primary provider. If Groq is unavailable, Alibaba Cloud (Singapore) is used when configured; otherwise the community pool.',
      groqApiKey: 'Groq API Key',
      groqApiKeyPlaceholder: 'Paste your API key here',
      groqApiKeyConfigured: '•••••••• (already configured in your account)',
      noApiKey: "Don't have an API key?",
      getApiKey: 'Get one free at Groq',
      getApiKeyNote: '(free, you just need to create an account)',
      saveApiKey: 'Save AI keys',
      alibabaSectionTitle: 'Alibaba Cloud (Singapore) — fallback',
      alibabaApiKey: 'Alibaba Cloud API Key',
      alibabaApiKeyPlaceholder: 'Paste your API key (international / Singapore region)',
      alibabaApiKeyConfigured: '•••••••• (already configured in your account)',
      alibabaModel: 'Qwen model',
      alibabaModelHelp: 'Type or pick a Model Studio ID (Singapore), e.g. qwen3.5-27b, qwen-plus. Must match Alibaba docs for your region.',
      alibabaGetApiKey: 'Get API key in Model Studio',
      alibabaStatus: 'Alibaba Cloud status',
      alibabaAvailable: 'Alibaba Cloud available',
      alibabaNotAvailable: 'Alibaba Cloud unavailable',
      alibabaConfigureKey: 'Configure your Alibaba API key to use it when Groq fails',
      alibabaEnableSearch: 'Web search (Alibaba)',
      alibabaEnableSearchHelp:
        'Only when Groq fails and Alibaba is used. Web search is slower/costlier. Alibaba cannot mix search + strict JSON mode; we parse JSON from the reply. Models: qwen3.6-flash, qwen3.5-plus. Not qwen3.5-27b.',
      alibabaEnableSearchModelOk: 'This model should support web search.',
      alibabaEnableSearchModelWarning:
        'This model likely does not support web search. Switch to qwen3.5-plus or qwen3-max and save.',
      alibabaEnableSearchModelBlocked:
        'This model (27b/120b, etc.) does not support web search. Use qwen3.6-flash or qwen3.5-plus.',
      alibabaEnableSearchModelTry:
        'With your model we will try enable_search on Alibaba fallback (save API key). If it fails, try qwen3.5-plus.',
      updateAlibabaStatus: 'Check status',
      systemStatus: 'System Status',
      aiConnected: 'AI Connected',
      aiDisconnected: 'AI Disconnected',
      groqQuota: 'Groq Quota',
      checkingQuota: 'Checking Groq quota...',
      groqAvailable: 'Groq available',
      requestsRemaining: '{remaining} requests remaining{limit}',
      noRequestsAvailable: 'No requests available',
      groqNotAvailable: 'Groq not available',
      retryAfter: 'Try again in {seconds} seconds',
      paymentRequired: 'Groq payment plan update required',
      updateQuotaToSee: 'Click "Update quota" to see your availability',
      configureApiKeyToSee: 'Configure your Groq API key to see your available quota',
      checking: 'Checking...',
      updateQuota: 'Update quota',
      noAIServiceNote: 'Without AI service, new automatic recommendations cannot be generated.',
      preferencesSummary: 'Preferences Summary',
      actors: 'Actors',
      genres: 'Genres',
      movieTypes: 'Movie types',
      minimumRatingLabel: 'Minimum rating',
      maxRecommendationsLabel: 'Max. recommendations',
      languageLabel: 'Language',
      ratingLabel: 'Rating'
    },
    // Rating modal
    ratingModal: {
      rateContent: 'Rate content',
      editRating: 'Edit Rating',
      rate: 'Rate',
      howWouldYouRate: 'How would you rate this content?',
      ratingMethod: 'Rating method',
      slider: 'Slider',
      stars: 'Stars',
      buttons: 'Buttons',
      thumbs: 'Thumbs',
      notes: 'Notes (optional)',
      save: 'Save',
      cancel: 'Cancel',
      markAsWatched: 'Mark as Watched',
      genre: 'Main genre',
      selectGenre: 'Select genre',
      selectGenreAria: 'Select music genre',
      selectGenrePlaceholder: '— Select genre —',
      correctGenre: 'Correct or add the genre if the API put "Various".',
      selectCorrectGenre: 'Choose the genre from the list. If the API put "Various", select the correct one.',
      contentInfo: 'Content Information',
      type: 'Type',
      genreLabel: 'Genre',
      year: 'Year',
      artist: 'Artist',
      director: 'Director',
      actors: 'Actors',
      rating: 'Rating',
      ratingValue: 'Rating: {value}/10',
      selectRating: 'Select a rating',
      veryBad: 'Very bad',
      bad: 'Bad',
      regular: 'Regular',
      good: 'Good',
      excellent: 'Excellent',
      didYouLike: 'Did you like it?',
      liked: 'Liked',
      disliked: 'Disliked',
      description: 'Description',
      whyRecommended: 'Why is this recommended?',
      notesPlaceholder: 'Share your opinion about this content...'
    },
    // Landing Page
    landing: {
      heroBadge: '✨ AI-Powered Entertainment Discovery',
      heroTitle: 'Discover Your Next',
      heroTitleHighlight: 'Favorite Movie, Series or Song',
      heroTitleSuffix: '',
      heroSubtitle: 'Stop wasting time scrolling. Get personalized recommendations powered by AI that learns from your actual viewing and listening history. Only real titles, with clear reasons why you\'ll love them.',
      featureRealTitles: '100% Real Titles',
      featureAIPowered: 'AI-Powered',
      featureFreeForever: 'Free Forever',
      ctaButton: 'Get Started Free',
      trustText: 'No credit card required',
      cardMovies: 'Movies',
      cardSeries: 'Series',
      cardMusic: 'Music',
      featuresTitle: 'Everything You Need to Discover Great Content',
      featuresSubtitle: 'A complete entertainment recommendation system that adapts to your taste',
      featurePersonalizedTitle: 'Personalized Recommendations',
      featurePersonalizedDesc: 'AI analyzes what you\'ve watched and listened to, suggesting real movies, series, and music with clear reasons for each recommendation.',
      featureRateTitle: 'Rate and Refine',
      featureRateDesc: 'Mark content as watched and rate it. Future recommendations will learn from what you liked and didn\'t like.',
      featureTrackTitle: 'Track Your Journey',
      featureTrackDesc: 'View detailed statistics: favorite genres, most listened artists, monthly activity, and rating distribution. Understand your entertainment habits.',
      featureSearchTitle: 'Smart Search & Filter',
      featureSearchDesc: 'Search for movies, series, and music. Filter recommendations by genre, type, or status. Find exactly what you\'re looking for.',
      featureControlTitle: 'Control Your Feed',
      featureControlDesc: 'Omit recommendations you\'re not interested in. Reactivate them later. Your recommendations adapt to your preferences.',
      featureOwnAITitle: 'Your Own AI (Optional)',
      featureOwnAIDesc: 'Use your own Groq API key for recommendations. Your data and API key stay private in your account.',
      howItWorksTitle: 'How It Works',
      howItWorksSubtitle: 'Three simple steps to better entertainment',
      step1Title: 'Sign In',
      step1Desc: 'Quick sign-in with your Google account. No passwords to remember.',
      step2Title: 'Rate What You\'ve Watched',
      step2Desc: 'Mark movies, series, and music you\'ve already enjoyed. The more you rate, the better recommendations.',
      step3Title: 'Get Personalized Recommendations',
      step3Desc: 'AI analyzes your preferences and suggests real titles you\'ll actually want to watch or listen to.',
      ctaTitle: 'Ready to Discover Your Next Favorite?',
      ctaSubtitle: 'Join thousands of users who are finding their perfect entertainment match.',
      ctaButtonSecondary: 'Sign in with Google',
      footerText: 'Movies, series, and music recommended by AI · Your data stays private in your account',
      footerCopyright: '© 2026 MisKosas · Powered by AI',
      latestNewsTitle: 'Latest news',
      latestNewsReadMore: 'Read more',
      latestNewsNone: 'No recent news.',
      allNewsLink: 'See all news here',
      // Auth errors
      errorGoogleNotConfigured: 'Google OAuth is not configured on the server.',
      errorGoogleAuthFailed: 'Error authenticating with Google. Please try again.',
      errorNoUser: 'Could not create or retrieve user.',
      errorCallback: 'Error in the authentication process.',
      errorSession: 'Error saving session.',
      errorSignIn: 'Error signing in with Google.',
      errorSignInGeneric: 'Error signing in.',
      errorConnection: 'Connection error.',
      // Modal
      modalCreateAccount: 'Create account',
      modalSignIn: 'Sign in',
      modalEmailLabel: 'Email',
      modalEmailPlaceholder: 'tu@email.com',
      modalNameLabel: 'Name (optional)',
      modalNamePlaceholder: 'Your name',
      modalPasswordLabel: 'Password',
      modalPasswordPlaceholder: 'Password',
      modalPasswordPlaceholderRegister: 'Minimum 6 characters',
      modalSignUp: 'Sign up',
      modalSignInButton: 'Sign in',
      modalAlreadyHaveAccount: 'I already have an account',
      modalCreateAccountLink: 'Create account',
      modalSignInEmail: 'Sign in with email'
    },
    // All news page
    publicLayout: {
      backToHome: 'Back to home',
      goToApp: 'Go to app'
    },
    cards: {
      typeMovie: 'Movie',
      typeSeries: 'Series',
      typeMusic: 'Music'
    },
    library: {
      segmentRecommendations: 'To discover',
      segmentWatched: 'Already watched',
      hintRecommendations: 'AI-suggested titles based on your taste. Mark them as watched when you finish them.',
      hintWatched: 'What you already marked as watched or listened. Edit ratings or return items to recommendations.'
    },
    allNews: {
      title: 'All news',
      subtitle: 'Blog articles and updates',
      backToHome: 'Back to home',
      loading: 'Loading news...',
      noPosts: 'No published news.',
      readMore: 'Read more'
    },
    // Groq Tutorial
    groqTutorial: {
      back: 'Back',
      title: 'How to Set Up Groq API for Real Recommendations',
      subtitle: 'Learn how to get your free Groq API key in less than 5 minutes',
      whyNeededTitle: 'Why do you need Groq?',
      whyNeeded: 'To generate real and personalized recommendations, we need access to advanced AI models. Groq provides this service quickly and affordably.',
      freeTitle: 'Free Plan Available',
      freeDescription: 'Groq offers a generous free plan with daily limits. For personal use, it\'s more than enough and doesn\'t require a credit card.',
      step1Title: 'Create a Groq Account',
      step1Description: 'Visit the Groq console and create a free account. You can use your Google account to sign in quickly.',
      openConsole: 'Open Groq Console',
      step1Note: 'Note: Registration is completely free and doesn\'t require a credit card.',
      step2Title: 'Generate Your API Key',
      step2Description: 'Once inside the console, go to the API Keys section and create a new key. Copy it immediately because it will only be shown once.',
      step2Code: 'gsk_xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
      copy: 'Copy',
      copied: 'Copied!',
      step3Title: 'Configure in MisKosas',
      step3Description: 'Now that you have your API Key, follow these steps to configure it:',
      step3Item1: 'Go to the Settings section in your dashboard',
      step3Item2: 'Paste your Groq API Key in the corresponding field',
      step3Item3: 'Save the changes and you\'re done! You can now generate real recommendations',
      goToSettings: 'Go to Settings',
      faqTitle: 'Frequently Asked Questions',
      faq1Question: 'Is it really free?',
      faq1Answer: 'Yes, Groq offers a free plan with generous limits. For personal recommendation use, it\'s more than enough. You would only pay if you exceed the free plan limits.',
      faq2Question: 'Do I need a credit card?',
      faq2Answer: 'No, Groq\'s free plan doesn\'t require a credit card. You can start using it immediately after creating your account.',
      faq3Question: 'Is it safe to share my API Key?',
      faq3Answer: 'Your API Key is stored securely in your account and only you can see it. Never share it publicly. In MisKosas, your key is stored encrypted and only used to generate your recommendations.',
      faq4Question: 'What happens if I exceed the free limits?',
      faq4Answer: 'Groq has very generous limits. If you exceed them, you can set spending limits in your Groq account or consider upgrading to a paid plan. Prices are very affordable (starting at $0.05 per million tokens).',
      readyTitle: 'Ready to get started?',
      readyDescription: 'Configure your Groq API Key now and start receiving real and personalized recommendations.',
      configureNow: 'Configure Now',
      learnMore: 'Learn more about Groq',
      linkText: 'View full tutorial'
    },
    // Common messages
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      confirm: 'Confirm',
      save: 'Save',
      delete: 'Delete',
      edit: 'Edit',
      close: 'Close',
      search: 'Search',
      filter: 'Filter',
      noResults: 'No results found',
      noData: 'No data available',
      note: 'Note',
      logout: 'Logout',
      aiServiceNotAvailable: 'AI service is not available. New automatic recommendations cannot be generated.',
      learnHowToConfigure: 'Learn how to configure Groq API for real recommendations →',
      errorLoadingData: 'Error loading data.',
      aiAvailable: 'AI available',
      aiNotAvailable: 'AI not available',
      errorGeneratingRecommendations: 'Error generating recommendations',
      generatingRecommendations: 'Generating recommendations...',
      errorMarkingWatched: 'Error marking content as watched.',
      errorUpdatingPreferences: 'Error updating preferences.',
      errorLoadingMovies: 'Error loading movies',
      errorLoadingSeries: 'Error loading series',
      errorLoadingMusic: 'Error loading music',
      errorMarkingListened: 'Error marking as listened',
      checkingAuth: 'Checking session...',
      // Blog
      blog: {
        loading: 'Loading...',
        error: 'Error',
        postNotFound: 'Post not found',
        errorLoading: 'Error loading post',
        backToHome: 'Back to home',
        views: 'views',
        rateThisContent: 'Rate this content',
        rateMovie: 'Rate this movie',
        rateSeries: 'Add this series to my list',
        rateMusic: 'Rate this song',
        goToRate: 'Go to rate',
        adminTitle: 'Blog Administration',
        newPost: 'New Post',
        editPost: 'Edit Post',
        title: 'Title',
        category: 'Category',
        status: 'Status',
        publishedAt: 'Published At',
        actions: 'Actions',
        noPosts: 'No posts yet',
        published: 'Published',
        draft: 'Draft',
        viewPost: 'View post',
        edit: 'Edit',
        delete: 'Delete',
        confirmDelete: 'Are you sure you want to delete this post?',
        errorDeleting: 'Error deleting post',
        errorSaving: 'Error saving post',
        saving: 'Saving...',
        save: 'Save',
        excerpt: 'Excerpt',
        excerptPlaceholder: 'Short summary of the post (optional)',
        excerptHelp: 'This text will appear in previews and meta tags',
        content: 'Content',
        contentPlaceholder: 'Write post content in HTML...',
        contentHelp: 'You can use HTML to format the content',
        featuredImage: 'Featured Image',
        imageUrlPlaceholder: 'Featured image URL',
        uploadImage: 'Upload image',
        uploadingImage: 'Uploading…',
        uploadImageHelp: 'Upload an image or paste a URL',
        seoSettings: 'SEO Settings',
        metaTitle: 'Meta Title',
        metaTitlePlaceholder: 'Title for SEO (optional, defaults to post title)',
        metaTitleHelp: 'If left empty, the post title will be used',
        metaDescription: 'Meta Description',
        metaDescriptionPlaceholder: 'Description for SEO (optional)',
        metaDescriptionHelp: 'Description that will appear in search results',
        metaKeywords: 'Meta Keywords',
        metaKeywordsPlaceholder: 'Keywords separated by commas',
        metaKeywordsHelp: 'Keywords for SEO (optional)',
        titlePlaceholder: 'Post title',
        adminAccessDenied: 'Access denied. Superuser role required.',
        accessDeniedOops: 'Oops!',
        accessDeniedTitle: "You shouldn't be here!",
        accessDeniedMessage: "This corner is for superusers only. Don't worry though, we'll get you back on track in a sec.",
        accessDeniedRedirect: 'Taking you back in {seconds} seconds...',
        generateWithAI: 'Generate with AI',
        generateTopicLabel: 'Article topic',
        generateTopicPlaceholder: 'E.g.: Selena Gomez new song, Dune 2 movie, The Last of Us series',
        generateTopicHelp: 'Describe in a few words what the article should be about (movie, series or music).',
        generating: 'Generating article...',
        generateError: 'Error generating article.',
        generateSuccess: 'Draft created. Review, add image if you want, and publish.',
        generateLanguageLabel: 'Article language',
        generateLanguageEs: 'Spanish',
        generateLanguageEn: 'English',
        generateLanguageHelp: 'Generate the same topic in another language for ES/EN versions.',
        usageTitle: 'Generation usage (Groq)',
        promptSentTitle: 'Prompt sent to LLM',
        promptSentSystem: 'System prompt',
        promptSentUser: 'User prompt',
        relatedTitleLabel: 'Real title (for Rate link)',
        relatedTitlePlaceholder: 'E.g. The Godfather',
        relatedYearLabel: 'Year (for Rate link)',
        relatedYearPlaceholder: '1972',
        usagePromptTokens: 'Prompt tokens',
        usageCompletionTokens: 'Completion tokens',
        usageTotalTokens: 'Total tokens',
        usageModel: 'Model',
        usageResponseTime: 'Response time',
        postLanguage: 'Post language (URL)',
        postLanguageHelp: 'ES: /noticias/peliculas/... — EN: /news/movies/...',
        searchPlaceholder: 'Search by title, slug or excerpt...',
        searchButton: 'Search',
        filterStatus: 'Status',
        filterStatusAll: 'All',
        filterStatusPublished: 'Published',
        filterStatusDraft: 'Drafts',
        searchImagesOnGoogle: 'Search large images on Google',
        page: 'Page',
        prev: 'Previous',
        next: 'Next',
        showingCount: 'Showing {from}-{to} of {total}',
        mightAlsoLike: 'You might also like'
      },
      loadingModalDefaultTitle: 'Generating recommendations...',
      loadingModalDefaultMessage: 'Consulting AI...',
      loadingModalCloseAndReload: 'Close and reload',
      loadingModalConnecting: 'Consulting AI...',
      loadingModalAnalyzing: 'Analyzing your preferences...',
      loadingModalGenerating: 'Generating personalized recommendations...',
      loadingModalDetecting: 'Detecting duplicates...',
      loadingModalSaving: 'Saving updated recommendations...',
      paginationShowing: 'Showing {from}–{to} of {total}',
      paginationPage: 'Page {page} of {totalPages}'
    }
  }
};

// Función para obtener traducción
export const t = (key, lang = 'es') => {
  // Validar y normalizar el idioma
  if (!lang || (lang !== 'es' && lang !== 'en')) {
    lang = 'es'; // Fallback a español por defecto
  }
  
  const keys = key.split('.');
  let value = translations[lang];
  
  // Si no existe el idioma, usar español como fallback
  if (!value) {
    value = translations.es;
  }
  
  for (const k of keys) {
    if (value && typeof value === 'object' && k in value) {
      value = value[k];
    } else {
      // Fallback a español si no encuentra la clave en el idioma actual
      value = translations.es;
      for (const k2 of keys) {
        if (value && typeof value === 'object' && k2 in value) {
          value = value[k2];
        } else {
          // Si aún no encuentra, devolver la clave
          logWarn(`Translation key not found: ${key} (lang: ${lang})`);
          return key;
        }
      }
      break;
    }
  }
  
  return typeof value === 'string' ? value : key;
};

// Función para formatear texto con variables
export const tf = (key, vars = {}, lang = 'es') => {
  let text = t(key, lang);
  Object.keys(vars).forEach(key => {
    text = text.replace(`{${key}}`, vars[key]);
  });
  return text;
};

export default translations;
